import { Link } from 'gatsby';
import { OutboundLink } from 'gatsby-plugin-gtag';
import { EuiSpacer } from '@elastic/eui';
import NavButtons from 'components/Outdoor_Cameras/IN-5907_HD/NavButtons';
import CompareFlyout from 'components/Products/Compare/CompareOutdoorFlyout';
import TableFeatures from 'components/Outdoor_Cameras/IN-5907_HD/TableFeatures';
import CompareTable from 'components/Outdoor_Cameras/IN-5907_HD/TableCompare';
import CompareGallery from 'components/Outdoor_Cameras/IN-5907_HD/GalleryCompare';
import OutdoorData from 'components/Products/Flyouts/Graphs/OutdoorGraphsFlyout';
import RadarGraphCard from 'components/Products/RadarGraphs/in5907-radargraph-grid';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  NavButtons,
  CompareFlyout,
  TableFeatures,
  CompareTable,
  CompareGallery,
  OutdoorData,
  RadarGraphCard,
  BreadCrumbs,
  SEOHelmet,
  React
};